import wx from 'weixin-js-sdk';
function detailResponse(data) {
	// body...
	var realdata = data.data;
	if (!realdata.success) {
		alert(realdata.message);
		return;
	}else{
		return realdata.data;
	}
}

function testname(argument){
	console.log("1234");
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
function onBridgeReady() {
	// 隐藏分享等按钮
	// WeixinJSBridge.call('hideOptionMenu');

	// wx.hideMenuItems({
	// 	menuList: ["menuItem:share:timeline", "menuItem:copyUrl", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone", "menuItem:editTag", "menuItem:delete", "menuItem:copyUrl", "menuItem:originPage", "menuItem:readMode", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:share:brand"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
	// });
}


if (typeof WeixinJSBridge == "undefined") {
	if (document.addEventListener) {
		document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
	} else if (document.attachEvent) {
		document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
		document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
	}
} else {
	onBridgeReady();
}

import Vue from 'vue';
export default new Vue;





// WEBPACK FOOTER //
// ./src/js/method.js